/**
 * Created by jv on 18/01/2017.
 */
const utils = require("Sources/utils/utils");
const Activation = require("Sources/models/activation");

module.exports = class Token
{
  constructor(options)
  {
    options = utils.isNotNull(options) ? options : {};

    this.code = options.code;
    this.key = options.key;
    this.platforms = options.platforms;
    this.maxInstallations = options["max-installations"];
    this.maxUsers = options["max-users"];
  };

  get activationType()
  {
    if(utils.isNotNull(this.maxInstallations) && utils.isNull(this.maxUsers))
    {
      return "installations";
    }
    else if(utils.isNull(this.maxInstallations) && utils.isNotNull(this.maxUsers))
    {
      return "users";
    }

    throw "Invalid activation type";
  }

  get currentActivationsCount()
  {
    return this.currentActivations.length;
  };

  set activations(activations)
  {
    this._activations = [];

    if(utils.isArray(activations))
    {
      for(var i = 0; i < activations.length; i++)
      {
        activations[i].tokenKey = this.key;
        activations[i].tokenCode = this.code;
        this._activations.push(new Activation(activations[i]));
      }
    }
  };

  get activations()
  {
    return utils.isArray(this._activations) ? this._activations : [];
  };

  getActivationForFakeKey(key)
  {
    for(var i = 0; i < this.activations.length; i++)
    {
      if(this.activations[i].fakeKey === key)
      {
        return this.activations[i];
      }
    }

    return null;
  }

  get currentActivations()
  {
    var currentActivations = [];

    for(var i = 0; i < this.activations.length; i++)
    {
      if(this.activations[i].current === true)
      {
        currentActivations.push(this.activations[i]);
      }
    }

    return currentActivations;
  };

  disableActivationForFakeKey(key)
  {
    for(var i = 0; i < this.activations.length; i++)
    {
      if(this.activations[i].fakeKey === key)
      {
        this.activations[i].current = false;
        return;
      }
    }

    throw "Activation with fakeKey [" + key + "] not found.";
  }

  enableActivationForFakeKey(key)
  {
    for(var i = 0; i < this.activations.length; i++)
    {
      if(this.activations[i].fakeKey === key)
      {
        this.activations[i].current = true;
        return;
      }
    }

    throw "Activation with fakeKey [" + key + "] not found.";
  }

  getHTMLIconsFormPlatforms()
  {
    var icons = "";

    for(var i = 0; i < this.platforms.length; i++)
    {
      var iconClass;

      switch(this.platforms[i])
      {
        case "picture_ios":
        case "avi_ios":
          iconClass = "icon-ios";
          break;
        case "picture_android":
          iconClass = "icon-android";
          break;
        case "picture_pc":
          iconClass = "icon-windows";
          break;
        case "avi_web":
          iconClass = "icon-desktop";
          break;
        default:
          break;
      }

      if(utils.isNotNull(iconClass))
      {
        icons += "<i class='icon " + iconClass + "' data-type='" + this.platforms[i] + "'/>";
      }
    }

    return icons;
  }
};



// WEBPACK FOOTER //
// ./app/js/models/token.js